var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15202 0 0 5.15202 0 11.5C0 17.8479 5.15202 23 11.5 23C17.8479 23 23 17.8479 23 11.5C23 5.15202 17.848 0 11.5 0ZM3.25065 11.5C3.25065 6.93065 6.9613 3.22 11.5 3.22C13.2173 3.22 14.8427 3.74135 16.1613 4.66131L4.69201 16.1613C3.772 14.8427 3.25065 13.2173 3.25065 11.5ZM11.5 19.7493C9.78264 19.7493 8.15729 19.228 6.83866 18.308L18.308 6.83866C19.228 8.15734 19.7493 9.78264 19.7493 11.5C19.7493 16.0693 16.0693 19.7493 11.5 19.7493Z",
    fill: "#D15241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.ab4c07c0c8e52f41028fcb4ab0bce80c.svg";
export { ForwardRef as ReactComponent };